import * as React from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  getCustomerTicketCount,
  getCustomerTicketAllDetailsExcel,
  getAllCustomers,
  getCustomerTicketDetailsExcel,
  updateCustomerTicketCount,
  syncCustomerTicketCount,
} from "../../../services/customers/CustomerService";
import { ToastContext } from "../../common/ToastProvider";
import { IDataCenter, ITicketCount, ITicketCountVM } from "../../../vm";
import moment from "moment";
import {
  Breadcrumb,
  Calendar,
  Callout,
  DayOfWeek,
  DefaultButton,
  DetailsListLayoutMode,
  DetailsRow,
  DirectionalHint,
  Fabric,
  FocusTrapZone,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  IIconProps,
  IListProps,
  PanelType,
  PrimaryButton,
  SelectionMode,
  ShimmeredDetailsList,
  Stack,
  Text,
  TextField,
  TooltipHost,
} from "@fluentui/react";
import {
  API_URL,
  childrenGap,
  childrenGap8,
  DayPickerStrings,
} from "../../common/Constants";
import { getAllDataCenters } from "../../../services/datacenter/DatacenterService";
import {
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiDotsVertical,
} from "@mdi/js";
import Icon from "@mdi/react";
import CustomDrawer from "../../common/CustomDrawer";
import TicketDetails from "./TicketDetails";
import NoDataTile from "../../common/NoDataTile";
import { Loading } from "../../../services/Loading";
import { getToken, parseJwt } from "../../../services/UtilService";
import RhsTicketsDetails from "./RhsTicketsDetails";

let calendarButtonElement: HTMLElement;

const shimmeredDetailsListProps: IListProps = {
  renderedWindowsAhead: 0,
  renderedWindowsBehind: 0,
};

export interface TicketMainProps { }

const TicketMain: React.FC<TicketMainProps> = () => {
  //hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const tokenData = parseJwt();

  const [state, setState] = React.useState({
    isLoading: false,
    data: [],
    date: new Date(),
    customer: {
      name: "",
    },
    datacenters: [],
    searchObj: {
      endDate: moment().endOf("month").toDate(),
      startDate: moment().startOf("month").toDate(),
      customerId: params.customerId,
    },
    showCalender: false,
    manageDialog: {
      isOpen: false,
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
    isOnEdit: false,
    index: undefined,
    ticketsObj: {
      _id: "",
      datacenterId: "",
      customerId: params.customerId,
      date: new Date(),
      "access-permission": 0,
      "material-movement": 0,
      // others: 0,
      "case-ticket": 0,
      "service-complaint": 0,
      "service-request": 0,
      "remote-hand-services": 0,
      rhsBillableHours: 0
    },
  } as {
    isLoading: boolean;
    data: ITicketCountVM[];
    datacenters: IDataCenter[];
    date: Date;
    searchObj: {
      startDate: Date | string;
      endDate: Date | string;
      customerId: string;
    };
    customer: {
      name: string;
    };
    showCalender: boolean;
    manageDialog: {
      isOpen: boolean;
      index?: number;
      data?: any;
    };
    manageActionsCallout: {
      isOpen: boolean;
      index?: number;
      element?: any;
      data?: any;
    };
    isOnEdit: boolean;
    index?: number;
    ticketsObj: ITicketCount;
  });

  // React.useLayoutEffect(() => {
  //   const asyncFunc = async () => {
  //     await searchDatacenters();
  //   };
  //   asyncFunc();
  // }, []);

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getTicketCounts(true);
    };
    asyncFunc();
  }, []);

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCalender: false,
    });
  };
  const onSearch = async () => {
    if (!state.date) {
      showToast("Please select a date before searching", "error");
    }

    getTicketCounts();
  };

  // const searchDatacenters = async () => {
  //   const result = await getAllDataCenters();
  //   if (result && result.success) {
  //     setState({ ...state, datacenters: result.data });
  //     console.log('result', result.data);
  //   }
  // };

  const getTicketCounts = async (isFirstSearch = false, searchObj?: any) => {
    setState({ ...state, isLoading: true });
    let tempSearch = { ...state.searchObj };
    if (searchObj) {
      tempSearch = { ...tempSearch, ...searchObj };
    }
    tempSearch.startDate = moment(tempSearch.startDate).format("YYYY-MM-DD");
    tempSearch.endDate = moment(tempSearch.endDate).format("YYYY-MM-DD");

    const result = await getCustomerTicketCount(tempSearch);
    if (result && result.success) {
      await getCustomerAndDatacenters(result.data, isFirstSearch);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result.message || "Error while getting Tickets Count", "error");
    }
  };

  const getCustomerAndDatacenters = async (
    data: ITicketCount[],
    isFirstSearch = false
  ) => {
    setState({ ...state, isLoading: true });
    const tempStateToUpdate: any = {
      isLoading: false,
      isOnEdit: false
    };
    if (isFirstSearch === true) {
      let result = await getAllCustomers({ customerId: params.customerId });
      if (result && result.success && result.data.length > 0) {
        tempStateToUpdate["customer"] = result.data[0];
      } else {
        setState({ ...state, isLoading: false });
        showToast(
          result.message || "Error while getting customer details",
          "error"
        );
      }

      const datacenterResp = await getAllDataCenters();
      if (datacenterResp && datacenterResp.success) {
        tempStateToUpdate["datacenters"] = datacenterResp.data;
      }
    }
    const datacenters = [
      ...(tempStateToUpdate["datacenters"] || []),
      ...state.datacenters,
    ];
    const dataArr: any = [];
    data.forEach((d) => {
      dataArr.push({
        location: datacenters.find((f) => f._id === d.datacenterId)?.location,
        // month: moment(state.date).format("MMM[']YY"),
        "total-srq":
          (d["access-permission"] || 0) +
          (d["material-movement"] || 0),
        // "total-srq":
        //   (d["access-permission"] || 0) +
        //   (d["material-movement"] || 0) +
        //   (d.others || 0),
        "total-complaint":
          (d["case-ticket"] || 0) +
          (d["service-complaint"] || 0) +
          (d["service-request"] || 0),
        "access-permission": d["access-permission"] || 0,
        "material-movement": d["material-movement"] || 0,
        // others: d.others || 0,
        "case-ticket": d["case-ticket"] || 0,
        "service-complaint": d["service-complaint"] || 0,
        "service-request": d["service-request"] || 0,
        "remote-hand-services": d["remote-hand-services"] || 0,
        datacenterId: d.datacenterId,
        customerId: d.customerId,
        date: d.date,
        _id: d._id as string,
        rhsBillableHours: d["rhsBillableHours"] || 0
      });
    });
    tempStateToUpdate["data"] = dataArr;
    setState({
      ...state,
      ...tempStateToUpdate,
    });
  };

  const handleOpenCloseDialog = (isOpen: boolean, index?: number) => {
    const temp: any = {
      isOpen: isOpen,
    };
    if (index != null) {
      temp["index"] = index;
      temp["data"] = state.data[index];
    }
    setState({ ...state, manageDialog: { ...temp } });
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <Stack horizontal tokens={childrenGap}>
            {state.isOnEdit && state.index === index ? (
              <React.Fragment>
                <TooltipHost
                  content={`Save`}
                  id={`saveTickets`}
                  calloutProps={{ gapSpace: 0 }}
                  styles={{ root: { display: "inline-block" } }}
                >
                  <span onClick={onUpdateTicketsCount}>
                    <Icon
                      path={mdiCheckCircleOutline}
                      size={0.8}
                      className="pointer"
                      color="green"
                    />
                  </span>
                </TooltipHost>
                <TooltipHost
                  content={`Cancel`}
                  id={`cancelTickets`}
                  calloutProps={{ gapSpace: 0 }}
                  styles={{ root: { display: "inline-block" } }}
                >
                  <span
                    onClick={() =>
                      setState({
                        ...state,
                        isOnEdit: false,
                        index: undefined,
                        ticketsObj: {
                          ...state.ticketsObj,
                          datacenterId: "",
                          date: new Date(),
                          _id: "",
                          "access-permission": 0,
                          "material-movement": 0,
                          // others: 0,
                          "case-ticket": 0,
                          "service-complaint": 0,
                          "service-request": 0,
                          "remote-hand-services": 0,
                          rhsBillableHours: 0
                        },
                      })
                    }
                  >
                    <Icon
                      path={mdiCloseCircleOutline}
                      size={0.8}
                      className="pointer"
                      color="red"
                    />
                  </span>
                </TooltipHost>
              </React.Fragment>
            ) : (
              <span
                onClick={(ele) =>
                  handleCallOutOpenClose(true, ele, index, item)
                }
              >
                <Icon
                  path={mdiDotsVertical}
                  size={0.9}
                  className="pointer"
                  color="#135c8a"
                />
              </span>
            )}
          </Stack>
          // <span
          //   onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          // >
          //   <Icon
          //     path={mdiDotsVertical}
          //     size={0.9}
          //     className="pointer"
          //     color="#135c8a"
          //   />
          // </span>
          // <------>
          // <Stack horizontal tokens={childrenGap}>
          //   <TooltipHost
          //     content={`View Details`}
          //     id={`viewTemp`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => handleOpenCloseDialog(true, index)}>
          //       <Icon
          //         path={mdiEyeOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      case "total-srq":
        return (
          <span>
            {(item["access-permission"] || 0) +
              (item["material-movement"] || 0)}
            {/* {(item["access-permission"] || 0) +
              (item["material-movement"] || 0) +
              (item.others || 0)} */}
          </span>
        );
      case "total-complaint":
        return (
          <span>
            {(item["case-ticket"] || 0) +
              (item["service-complaint"] || 0) +
              (item["service-request"] || 0)}
          </span>
        );
      case "access-permission":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.ticketsObj["access-permission"])}
                type="number"
                name="access-permission"
                onChange={(event: any) => handleChange(event, false)}
                className="width-80"
              />
            ) : (
              item["access-permission"]
            )}
          </React.Fragment>
        );
      case "material-movement":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.ticketsObj["material-movement"])}
                type="number"
                name="material-movement"
                onChange={(event: any) => handleChange(event, false)}
                className="width-80"
              />
            ) : (
              item["material-movement"]
            )}
          </React.Fragment>
        );
      // case "others":
      //   return (
      //     <React.Fragment>
      //       {state.isOnEdit && state.index === index ? (
      //         <TextField
      //           value={String(state.ticketsObj.others)}
      //           type="number"
      //           name="others"
      //           onChange={(event: any) => handleChange(event, false)}
      //           className="width-80"
      //         />
      //       ) : (
      //         item.others
      //       )}
      //     </React.Fragment>
      //   );
      case "case-ticket":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.ticketsObj["case-ticket"])}
                type="number"
                name="case-ticket"
                onChange={(event: any) => handleChange(event, false)}
                className="width-80"
              />
            ) : (
              item["case-ticket"]
            )}
          </React.Fragment>
        );
      case "service-complaint":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.ticketsObj["service-complaint"])}
                type="number"
                name="service-complaint"
                onChange={(event: any) => handleChange(event, false)}
                className="width-80"
              />
            ) : (
              item["service-complaint"]
            )}
          </React.Fragment>
        );
      case "service-request":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.ticketsObj["service-request"])}
                type="number"
                name="service-request"
                onChange={(event: any) => handleChange(event, false)}
                className="width-80"
              />
            ) : (
              item["service-request"]
            )}
          </React.Fragment>
        );
      case "remote-hand-services":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.ticketsObj["remote-hand-services"])}
                type="number"
                name="remote-hand-services"
                onChange={(event: any) => handleChange(event, false)}
                className="width-80"
              />
            ) : (
              item["remote-hand-services"]
            )}
          </React.Fragment>
        );
      case "rhsBillableHours":
        return (
          <React.Fragment>
            {state.isOnEdit && state.index === index ? (
              <TextField
                value={String(state.ticketsObj["rhsBillableHours"])}
                type="number"
                name="rhsBillableHours"
                onChange={(event: any) => handleChange(event, true)}
                className="width-80"
              />
            ) : (
              Number(item["rhsBillableHours"] || 0).toFixed(2)
            )}
          </React.Fragment>
        );
      case "location":
        return (
          <Text style={{ fontWeight: 600 }}>
            {item[column.fieldName as any]}
          </Text>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const handleChange = (e: any, isBillableHours: boolean) => {
    setState({
      ...state,
      ticketsObj: {
        ...state.ticketsObj,
        [e.target.name]: !isBillableHours ? parseInt(e.target.value) : Number(e.target.value),
      },
    });
  };

  const onUpdateTicketsCount = async () => {
    let ticketsObj = { ...state.ticketsObj };

    if (!ticketsObj["access-permission"]) {
      ticketsObj["access-permission"] = 0;
    }
    if (!ticketsObj["material-movement"]) {
      ticketsObj["material-movement"] = 0;
    }
    // if (!ticketsObj.others) {
    //   ticketsObj.others = 0;
    // }
    if (!ticketsObj["case-ticket"]) {
      ticketsObj["case-ticket"] = 0;
    }
    if (!ticketsObj["service-complaint"]) {
      ticketsObj["service-complaint"] = 0;
    }
    if (!ticketsObj["service-request"]) {
      ticketsObj["service-request"] = 0;
    }
    if (!ticketsObj["remote-hand-services"]) {
      ticketsObj["remote-hand-services"] = 0;
    }
    if (!ticketsObj["rhsBillableHours"]) {
      ticketsObj["rhsBillableHours"] = 0;
    }

    setState({ ...state, isLoading: true });
    let result = await updateCustomerTicketCount(ticketsObj);
    if (result?.success) {
      let data = [...state.data];
      if (state.manageActionsCallout.index !== undefined) {
        data[state.manageActionsCallout.index]["access-permission"] =
          ticketsObj["access-permission"] || 0;
        data[state.manageActionsCallout.index]["material-movement"] =
          ticketsObj["material-movement"] || 0;
        // data[state.manageActionsCallout.index].others = ticketsObj.others || 0;
        data[state.manageActionsCallout.index]["case-ticket"] =
          ticketsObj["case-ticket"] || 0;
        data[state.manageActionsCallout.index]["service-complaint"] =
          ticketsObj["service-complaint"] || 0;
        data[state.manageActionsCallout.index]["service-request"] =
          ticketsObj["service-request"] || 0;
        data[state.manageActionsCallout.index]["remote-hand-services"] =
          ticketsObj["remote-hand-services"] || 0;
        data[state.manageActionsCallout.index]["rhsBillableHours"] =
          ticketsObj["rhsBillableHours"] || 0;
      }
      setState({
        ...state,
        ticketsObj: {
          ...state.ticketsObj,
          datacenterId: "",
          date: new Date(),
          _id: "",
          "access-permission": 0,
          "material-movement": 0,
          // others: 0,
          "case-ticket": 0,
          "service-complaint": 0,
          "service-request": 0,
          "remote-hand-services": 0,
          rhsBillableHours: 0
        },
        isOnEdit: false,
        manageActionsCallout: {
          isOpen: false,
          index: undefined,
          element: undefined,
          data: undefined,
        },
        index: undefined,
        isLoading: false,
      });
      showToast("Tickets count updated successfully", "success");
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while updating tickets count",
        "error"
      );
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: any
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  // let isServiceTicket = window.location.pathname.endsWith("service-tickets");
  let url: string;
  // if (window.location.pathname.endsWith("service-tickets")) {
  //   url = "service-tickets";
  if (window.location.pathname.endsWith("access-permission-and-material-movement")) {
    url = "access-permission-and-material-movement";
  } else if (window.location.pathname.endsWith("complaints-and-other-requests")) {
    url = "complaints-and-other-requests";
    // } else if (window.location.pathname.endsWith("incidents")) {
    //   url = "incidents";
  } else {
    url = "remote-hand-services";
  }

  const downloadReport = async (datacenterId?: string) => {
    let result: any;
    let title = "Access Permission & Material Movement";
    // let title = "Service Requests";
    // if (url === "service-tickets") {
    if (url === "access-permission-and-material-movement") {
      let searchObj: any = { ...state.searchObj };
      searchObj.datacenterId = datacenterId ? datacenterId : "";
      searchObj.startDate = moment(searchObj.startDate).format("YYYY-MM-DD");
      searchObj.endDate = moment(searchObj.endDate).format("YYYY-MM-DD");
      searchObj.types = 'access-permission,material-movement';
      result = await getCustomerTicketAllDetailsExcel({
        ...searchObj,
      });
      title = "Access Permission & Material Movement";
      // title = "Service Requests";
      // console.log("service-ticket");
    } else if (url === "complaints-and-other-requests") {
      // } else if (url === "incidents") {
      let searchObj: any;
      searchObj = { ...state.searchObj };
      // searchObj.type = "case-ticket";
      searchObj.datacenterId = datacenterId ? datacenterId : "";
      searchObj.startDate = moment(searchObj.startDate).format("YYYY-MM-DD");
      searchObj.endDate = moment(searchObj.endDate).format("YYYY-MM-DD");
      searchObj.types = 'complaint,service-complaint,service-request';

      result = await getCustomerTicketAllDetailsExcel({
        ...searchObj,
      });
      // result = await getCustomerTicketDetailsExcel({
      //   ...searchObj,
      // });
      title = "Complaints & Other Requests";
      // title = "Incident Requests";
      // console.log("incident");
    } else {
      let searchObj: any;
      searchObj = { ...state.searchObj };
      // searchObj.type = "remote-hand-services";
      searchObj.datacenterId = datacenterId ? datacenterId : "";
      searchObj.startDate = moment(searchObj.startDate).format("YYYY-MM-DD");
      searchObj.endDate = moment(searchObj.endDate).format("YYYY-MM-DD");
      // result = await getCustomerTicketDetailsExcel({
      //   ...searchObj,
      // });
      title = "RHS Requests";
      let result = await fetch(
        `${API_URL}rhs-tickets/report?customerId=${searchObj.customerId
        }&startDate=${searchObj.startDate}&endDate=${searchObj.endDate}&datacenterId=${searchObj.datacenterId}`,
        {
          method: "GET",
          credentials: 'include', // Enable credentials for CORS
          headers: {
            at: getToken(),
          },
        }
      );
      let pdf = await result.blob();
      const pdfFile = await new Blob([pdf], { type: "application/pdf" });
      const pdfFileURL = await URL.createObjectURL(pdfFile);
      var a: any = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display:none";
      a.href = pdfFileURL;
      a.download = `${state.customer.name} ${title}.pdf`;
      a.click();
      // console.log("remote-hand-services");
    }

    // for service tickets & incidents xl will be downloaded And for RHS pdf
    if (!["remote-hand-services"].includes(url)) {
      let xlsx = await result.blob();
      const pdfFile = await new Blob([xlsx], {
        type: "application/vnd.openxmlformats",
      });
      const pdfFileURL = await URL.createObjectURL(pdfFile);
      var a: any = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display:none";
      a.href = pdfFileURL;
      // a.download = `${state.customer.name} Service Requests.xlsx`;
      a.download = `${state.customer.name} ${title}.xlsx`;
      a.click();
    }
  };

  const getBreadCrumbItems = (
    type: "access-permission-and-material-movement" | "complaints-and-other-requests" | "remote-hand-services"
    // type: "service-tickets" | "incidents" | "remote-hand-services"

  ) => {
    const items: any = [
      {
        text: state.customer.name,
        key: "name",
        onClick: () => {
          history.push(`/customers/${params.customerId}`);
        },
      },
    ];
    switch (type) {
      case "access-permission-and-material-movement": {
        items.push({
          text: "Access Permission & Material Movement",
          key: "access-permission-and-material-movement",
          isCurrentItem: true,
        });
        break;
      }
      // case "service-tickets": {
      //   items.push({
      //     text: "Service Tickets",
      //     key: "service-tickets",
      //     isCurrentItem: true,
      //   });
      //   break;
      // }
      case "complaints-and-other-requests": {
        items.push({
          text: "Complaints & Other Requests",
          key: "complaints-and-other-requests",
          isCurrentItem: true,
        });
        break;
      }
      // case "incidents": {
      //   items.push({
      //     text: "Incidents",
      //     key: "incidents",
      //     isCurrentItem: true,
      //   });
      //   break;
      // }
      case "remote-hand-services": {
        items.push({
          text: "Remote Hand Services",
          key: "remote-hand-services",
          isCurrentItem: true,
        });
      }
    }
    return items;
  };

  const getColumns = (
    type: "access-permission-and-material-movement" | "complaints-and-other-requests" | "remote-hand-services"
    // type: "service-tickets" | "incidents" | "remote-hand-services"
  ) => {
    const columns: IColumn[] = [
      {
        key: "location",
        name: "Location",
        fieldName: "location",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      },
      // {
      //   key: 'month',
      //   name: 'Month',
      //   fieldName: 'month',
      //   minWidth: 200,
      //   maxWidth: 250,
      //   isResizable: true,
      // },
    ];
    switch (type) {
      case "access-permission-and-material-movement": {
        // case "service-tickets": {
        columns.push({
          key: "total-srq",
          name: "Total SRQ",
          fieldName: "total-srq",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "access-permission",
          name: "Access Request",
          fieldName: "access-permission",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "material-movement",
          name: "Material Movement",
          fieldName: "material-movement",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        // columns.push({
        //   key: "others",
        //   name: "Others",
        //   fieldName: "others",
        //   minWidth: 200,
        //   maxWidth: 250,
        //   isResizable: true,
        // });
        break;
      }
      case "complaints-and-other-requests": {
        // case "incidents": {
        columns.push({
          key: "total-complaint",
          name: "Total",
          fieldName: "total-complaint",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "case-ticket",
          name: "Incident (Complaint)",
          // name: "Case Tickets",
          fieldName: "case-ticket",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "service-complaint",
          name: "Service Complaint",
          fieldName: "service-complaint",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "service-request",
          name: "Service Request",
          fieldName: "service-request",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        break;
      }
      case "remote-hand-services": {
        columns.push({
          key: "remote-hand-services",
          name: "Remote Hand Services",
          fieldName: "remote-hand-services",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "rhsBillableHours",
          name: "Billable Hours",
          fieldName: "rhsBillableHours",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        break;
      }
    }
    columns.push({
      key: "actions",
      name: "Actions",
      fieldName: "action",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    });
    return columns;
  };

  const syncIcon: IIconProps = { iconName: "SyncOccurence" };

  const syncCount = async () => {
    setState({ ...state, isLoading: true });
    let tempSearch = { ...state.searchObj };

    tempSearch.startDate = moment(tempSearch.startDate).format("YYYY-MM-DD");
    tempSearch.endDate = moment(tempSearch.endDate).format("YYYY-MM-DD");
    let result = await syncCustomerTicketCount(tempSearch);
    if (result?.success) {
      const dataArr: any = [];
      result.data.forEach((d: any) => {
        dataArr.push({
          location: state.datacenters.find((f) => f._id === d.datacenterId)
            ?.location,
          // month: moment(state.date).format("MMM[']YY"),
          "total-srq":
            (d["access-permission"] || 0) +
            (d["material-movement"] || 0),
          // "total-srq":
          //   (d["access-permission"] || 0) +
          //   (d["material-movement"] || 0) +
          //   (d.others || 0),
          "total-complaint":
            (d["case-ticket"] || 0) +
            (d["service-request"] || 0) +
            (d["service-complaint"] || 0),
          "access-permission": d["access-permission"] || 0,
          "material-movement": d["material-movement"] || 0,
          // others: d.others || 0,
          "case-ticket": d["case-ticket"] || 0,
          "service-complaint": d["service-complaint"] || 0,
          "service-request": d["service-request"] || 0,
          "remote-hand-services": d["remote-hand-services"] || 0,
          "rhsBillableHours": d["rhsBillableHours"] || 0,
          datacenterId: d.datacenterId,
          customerId: d.customerId,
          date: d.date,
          _id: d._id as string,
        });
      });
      setState({ ...state, data: dataArr, isLoading: false });
    } else {
      setState({ ...state, isLoading: false });
      showToast(result?.message || "Can't sync", "error");
    }
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Breadcrumb items={getBreadCrumbItems(url as any)} />
        </Stack.Item>
        <Stack.Item>
          <Stack
            horizontal
            wrap
            tokens={childrenGap}
            horizontalAlign="space-between"
          >
            <Stack.Item>
              <Stack tokens={childrenGap} horizontal horizontalAlign="start">
                <Stack.Item>
                  <div
                    ref={(calendarBtn) =>
                      (calendarButtonElement = calendarBtn!)
                    }
                  >
                    <DefaultButton
                      text={
                        !state.date
                          ? "Select a month"
                          : moment(state.date).format("MMM-YYYY")
                      }
                      onClick={() => setState({ ...state, showCalender: true })}
                      className="month-picker-btn"
                    />
                  </div>
                  {state.showCalender && (
                    <Callout
                      isBeakVisible={false}
                      // className="ms-DatePicker-callout"
                      gapSpace={0}
                      doNotLayer={false}
                      target={calendarButtonElement}
                      directionalHint={DirectionalHint.bottomLeftEdge}
                      onDismiss={() => closeCallender()}
                      setInitialFocus
                    >
                      <FocusTrapZone
                        firstFocusableSelector="ms-DatePicker-day--today"
                        isClickableOutsideFocusTrap
                      >
                        <Calendar
                          // eslint-disable-next-line react/jsx-no-bind
                          onSelectDate={(date: Date | null | undefined) =>
                            setState({
                              ...state,
                              date: date as any,
                              searchObj: {
                                ...state.searchObj,
                                startDate: moment(date)
                                  .startOf("month")
                                  .toDate(),
                                endDate: moment(date).endOf("month").toDate(),
                              },
                              showCalender: false,
                            })
                          }
                          onDismiss={() => closeCallender()}
                          isMonthPickerVisible={true}
                          value={state.date}
                          firstDayOfWeek={DayOfWeek.Sunday}
                          strings={DayPickerStrings}
                          isDayPickerVisible={false}
                          highlightCurrentMonth={false}
                          highlightSelectedMonth={true}
                          showMonthPickerAsOverlay={false}
                          showGoToToday={false}
                        />
                      </FocusTrapZone>
                    </Callout>
                  )}
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            <Stack.Item>
              <Stack wrap tokens={childrenGap} horizontal>
                {!["remote-hand-services"].includes(url) && (<Stack.Item>
                  <DefaultButton
                    text="Download Details Report"
                    disabled={
                      state.isLoading === true || state.data.length === 0
                    }
                    onClick={() => {
                      downloadReport();
                    }}
                    className="custom-secondary-btn"
                  />
                </Stack.Item>)}
                {![2, 4, 5].includes(tokenData.role) && (
                  <Stack.Item align="end">
                    <PrimaryButton
                      text="Sync Count"
                      onClick={() => syncCount()}
                      iconProps={syncIcon}
                    />
                  </Stack.Item>
                )}
              </Stack>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.data.length > 0 ? (
            <Fabric>
              <ShimmeredDetailsList
                items={state.data}
                columns={getColumns(url as any)}
                onRenderItemColumn={_renderItemColumn as any}
                onShouldVirtualize={() => false}
                enableShimmer={state.isLoading}
                compact={true}
                setKey="ticketCounts"
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                listProps={shimmeredDetailsListProps}
                onRenderRow={_onRenderRow}
              />
            </Fabric>
          ) : (
            <NoDataTile title="No Tickets Generated" />
          )}
        </Stack.Item>
      </Stack>

      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 115, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleOpenCloseDialog(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                View
              </span>
            </Stack.Item>
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    setState({
                      ...state,
                      ticketsObj: {
                        _id: state.manageActionsCallout.data?._id,
                        datacenterId:
                          state.manageActionsCallout.data?.datacenterId,
                        date: state.manageActionsCallout.data?.date,
                        customerId: params.customerId,
                        "access-permission":
                          state.manageActionsCallout.data["access-permission"],
                        "material-movement":
                          state.manageActionsCallout.data["material-movement"],
                        // others: state.manageActionsCallout.data?.others,
                        "case-ticket":
                          state.manageActionsCallout.data["case-ticket"],
                        "service-complaint":
                          state.manageActionsCallout.data["service-complaint"],
                        "service-request":
                          state.manageActionsCallout.data["service-request"],
                        "remote-hand-services":
                          state.manageActionsCallout.data["remote-hand-services"],
                        rhsBillableHours: state.manageActionsCallout.data["rhsBillableHours"]
                      },
                      manageActionsCallout: {
                        ...state.manageActionsCallout,
                        isOpen: false,
                      },
                      isOnEdit: true,
                      index: state.manageActionsCallout.index,
                    });
                  }}
                  className="callout-options"
                >
                  Edit
                </span>
              </Stack.Item>
            )}
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  downloadReport(
                    state.manageActionsCallout.data.datacenterId as string
                  );
                }}
                className="callout-options"
              >
                Download
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}

      <CustomDrawer
        drawerType={PanelType.extraLarge}
        onClose={() => {
          handleOpenCloseDialog(false);
        }}
        handelOpen={state.manageDialog.isOpen}
        title={"Ticket Details"}
      >
        {url === "remote-hand-services" ? (
          <RhsTicketsDetails
            data={state.manageDialog.data}
            customerId={params.customerId}
            startDate={state.searchObj.startDate}
            endDate={state.searchObj.endDate}
            datacenter={state.datacenters.find((d) => d._id === state.manageDialog?.data?.datacenterId) as IDataCenter}
          />
        ) : (
          <TicketDetails
            data={state.manageDialog.data}
            customerId={params.customerId}
            startDate={state.searchObj.startDate}
            endDate={state.searchObj.endDate}
            customer={state.customer}
            url={url}
          />
        )}
      </CustomDrawer>
    </React.Fragment>
  );
};

export default TicketMain;
